module.exports = __webpack_public_path__ + "img/tj.a8ed5244.svg";